import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { SprayEventMultipleOperatorsTabState } from './types';

const selectSprayEventMultipleOperatorsTabState = (
    state: AppState
): SprayEventMultipleOperatorsTabState => state.sprayEventMultipleOperatorsTab;

const selectSprayEventMultipleOperatorsTabActiveIndex = createDeepEqualSelector(
    selectSprayEventMultipleOperatorsTabState,
    (sprayEventMultipleOperatorsTabState) =>
        sprayEventMultipleOperatorsTabState &&
        sprayEventMultipleOperatorsTabState.activeIndex
);

const makeSelectSprayEventMultipleOperatorsTabActiveIndex =
    (): typeof selectSprayEventMultipleOperatorsTabActiveIndex =>
        selectSprayEventMultipleOperatorsTabActiveIndex;

export {
    selectSprayEventMultipleOperatorsTabState,
    makeSelectSprayEventMultipleOperatorsTabActiveIndex
};
